import { Space, Typography } from 'antd'
import { HelpMessage } from 'utils/constants'
import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { CIMSTag } from 'components/CIMSTag'
import PermissionViewer from '../../../../PermissionViewer'
import { useUsersTableContext } from '../../../UsersTableContext'
import ImplicitPermissionViewer from '../../../../ImplicitPermissionViewer'
import { User } from '../../../UsersTableContext/types'

export function useExpandOptions(): ExpandOptions<User> {
  const { customFields } = useUsersTableContext()
  const help = HelpMessage.Administration.Users
  return {
    render: (user) => {
      const { id, givenName, surname, roles, permissions, admin, developer } =
        user
      return {
        additionalInfo: [
          {
            label: 'Azure ObjectID',
            children: <Typography.Text copyable>{id}</Typography.Text>,
            help: help.ID,
          },
          {
            label: 'Given Name',
            children: givenName,
            help: help.GivenName,
          },
          {
            label: 'Surname',
            children: surname,
            help: help.Surname,
          },
          {
            label: 'Explicit Permissions',
            type: 'default',
            help: {
              content: (
                <Space
                  size={'small'}
                  direction="vertical"
                  style={{
                    maxWidth: 250,
                    wordWrap: 'break-word',
                    wordBreak: 'break-word',
                  }}
                >
                  <Typography.Text>
                    {HelpMessage.Administration.Users.ExplicitPermissions}
                  </Typography.Text>
                  <Typography.Text>
                    {HelpMessage.Administration.Users.GreyTags}
                  </Typography.Text>
                  <Typography.Text>
                    {HelpMessage.Administration.Users.BlueTags}
                  </Typography.Text>
                  <Typography.Text>
                    {HelpMessage.Administration.Users.PurpleTags}
                  </Typography.Text>
                  <div>
                    <CIMSTag>Role Permission</CIMSTag>
                    <CIMSTag color="blue">Additional Permission</CIMSTag>
                    <CIMSTag color="purple">Project Admin</CIMSTag>
                    <CIMSTag color="purple">Developer</CIMSTag>
                  </div>
                </Space>
              ),
            },
            children:
              admin || developer ? (
                'Full Access'
              ) : (
                <PermissionViewer
                  roles={roles}
                  additionalPermissionIds={permissions}
                />
              ),
          },
          {
            label: 'Implicit Permissions',
            type: 'default',
            help: HelpMessage.Administration.Users.ImplicitPermissions,
            children:
              admin || developer ? (
                'Full Access'
              ) : (
                <ImplicitPermissionViewer
                  user={user}
                  customFields={customFields}
                />
              ),
          },
        ],
      }
    },
  }
}
